import { render, staticRenderFns } from "./AccountTransferVerificationStep.vue?vue&type=template&id=315afbda&scoped=true&"
import script from "./AccountTransferVerificationStep.vue?vue&type=script&lang=ts&"
export * from "./AccountTransferVerificationStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315afbda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard})
